var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 15.75C8.49632 15.75 9 15.2463 9 14.625C9 14.0037 8.49632 13.5 7.875 13.5C7.25368 13.5 6.75 14.0037 6.75 14.625C6.75 15.2463 7.25368 15.75 7.875 15.75Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15.75C13.7463 15.75 14.25 15.2463 14.25 14.625C14.25 14.0037 13.7463 13.5 13.125 13.5C12.5037 13.5 12 14.0037 12 14.625C12 15.2463 12.5037 15.75 13.125 15.75Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75007 9.74996H11.2501V7.50746H13.4926V6.00746H11.2501V3.77246H9.75007V6.00746H7.50757V7.50746H9.75007V9.74996Z",
    fill: "#637381"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.75H13.5C13.6511 12.7496 13.7985 12.7035 13.923 12.6178C14.0474 12.5322 14.1431 12.411 14.1975 12.27L16.32 6.75H14.715L12.9825 11.25H8.0025L4.635 3.1725C4.52082 2.8988 4.32808 2.66508 4.08112 2.50089C3.83415 2.33669 3.54406 2.24939 3.2475 2.25H1.5V3.75H3.2475L6.81 12.285C6.86626 12.422 6.96181 12.5392 7.0846 12.622C7.20739 12.7047 7.35193 12.7493 7.5 12.75Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation1);
export default __webpack_public_path__ + "static/media/quotation1.d6e57d5794bbf0ddef00cc24ec254020.svg";
export { ForwardRef as ReactComponent };